import Toast from '../../../Helpers/Toast';
import {http} from '../../../services/config';
import errorMsg from '../../../locales/errorMsg';
import {documentApiPrefix, isV3Signer} from '../../../services/clicksignVersion';

export default {
    getIndexDocument({commit, dispatch}, {filter = '', page = 1, filters = {}, perpage = null}) {
        commit('changeLoading', true);
        if (filter === 'all') {
            if (filters.status && filters.status !== 'all') {
                filter = filters.status;
            } else {
                filter = null
            }
        }
        if (filter === 'pendingadm' || filters.pendingBy) {
            dispatch('getPendingAdm', {page, filters, perpage});
            return;
        }
        http.get('v1/documentos', {params: {filter: filter, page: page, filters, perpage}}).then(resp => {
            commit('setIndexDocument', resp.data);
            commit('changeLoading', false);
        }).catch(() => {
            commit('setIndexDocument', {});
            commit('changeLoading', false);
        });
    },
    getPendingAdm({commit}, {page = 1, term = null, filters = {}, perpage}) {
        commit('changeLoading', true);
        http.get(`v1/documentos/pending-sign?pendingBy=${filters?.pendingBy ? filters.pendingBy : 'seller,witness'}${filters?.pendingBy?'':'&notPendingBy=buyer,sign,broker'}`, {
            params: {
                page: page,
                term: term,
                filters,
                perpage,
            }
        }).then(resp => {
            commit('setIndexDocument', resp.data);
            commit('changeLoading', false);
        }).catch(() => {
            commit('setIndexDocument', {});
            commit('changeLoading', false);
        });
    },
    showDocument({commit}, document) {
        commit('changeLoading', true);
        http.get(`${documentApiPrefix(document)}/${document.id}`).then(resp => {
            commit('changeLoading', false);
            if (resp.data.validations) return;
            window.open(resp.data.original_file_url, '_blank');
        }).catch(() => {
            commit('changeLoading', false);
        });
    },
    showDocumentSigned({commit}, document) {
        commit('changeLoading', true);
        http.get(`${documentApiPrefix(document)}/${document.id}`).then(resp => {
            commit('changeLoading', false);
            if (resp.data.validations) return;
            window.open(resp.data.signed_file_url, '_blank');
        }).catch(() => {
            commit('changeLoading', false);
        });
    },
    async sendWhatsappMessage({commit}, {whatsapp, showLoading = true}) {
        showLoading && commit('changeLoading', true);
        if (!whatsapp?.company_name) whatsapp.company_name = localStorage.getItem('company_name');

        await http.post('v1/signatarios/whatsapp', whatsapp).then(() => {
            Toast.success(`Notificação Enviada: ${whatsapp?.name ? whatsapp.name : ''}`);
            showLoading && commit('changeLoading', false);
        }).catch((err) => {
            let motiv = err?.response?.data?.message ? `; Motivo: ${err.response.data.message}` : '';
            Toast.error(`Falha ao Notificar: ${whatsapp?.name ? whatsapp.name : ''} ${motiv}`);
            showLoading && commit('changeLoading', false);
        });
    },
    async preparePresentialSession({commit}, {signer}) {
        commit('changeLoading', true);

        return await http.post(`v1/signatarios/${signer.id}/presential-session`).then((resp) => {
            const session = resp?.data?.session || {};
            const sessionUrl = session.url || null;
            const sessionToken = session.token || null;
            const sessionQrCode = session.qr_code || null;
            const hostEmail = resp?.data?.session?.host?.email || signer?.signature_host?.email;

            if (sessionUrl) {
                navigator.clipboard.writeText(sessionUrl);
                Toast.success('Link da sessao presencial copiado com sucesso!');
            } else if (sessionToken) {
                navigator.clipboard.writeText(sessionToken);
                Toast.success('Token da sessao presencial copiado com sucesso!');
            } else if (sessionQrCode) {
                navigator.clipboard.writeText(sessionQrCode);
                Toast.success('QR Code da sessao presencial copiado com sucesso!');
            } else {
                Toast.error(hostEmail
                    ? `A sessao presencial foi solicitada, mas a Clicksign nao retornou link, token ou QR Code para o anfitriao ${hostEmail}. Nao foi possivel confirmar um acesso utilizavel.`
                    : 'A sessao presencial foi solicitada, mas a Clicksign nao retornou link, token ou QR Code. Nao foi possivel confirmar um acesso utilizavel.');
            }
            commit('changeLoading', false);
            return resp.data;
        }).catch((err) => {
            commit('changeLoading', false);
            errorMsg.errorMsg(err);
            throw err;
        });
    },
    plusSingleDocumentExpiration({commit, state}, {day, item})
    {
        commit('changeLoading', true);
        http.patch(`${documentApiPrefix(item)}/${item.id}/aumentar-tempo-expiracao`,{acrescentar_dias:day}).then(() => {
            document.getElementById('closeX')?.click();
            state.reloadIndex = true;
            Toast.success('DOCUMENTS.EXPIRATION_PLUS_SUCESS');
        }).catch((err) => {
            commit('changeLoading', false);
            errorMsg.errorMsg(err);
        })
    },
    plusAllDocumentExpiration({commit, state}, {day, start_date, end_date})
    {
        commit('changeLoading', true);
        http.post(`v1/documentos/aumentar-tempo-lote-documentos`,{acrescentar_dias:day, end_date,start_date}).then((resp) => {
            document.getElementById('closeX')?.click();
            state.reloadIndex = true;
            if (resp.data?.validations?.message){
                Toast.success(resp.data.validations.message);
            }else {
                Toast.success('DOCUMENTS.EXPIRATION_PLUS_SUCESS');
            }
        }).catch((err) => {
            commit('changeLoading', false);
            errorMsg.errorMsg(err);
        })
    },
    actionCancelDocument({commit}, {document}) {
        commit('changeLoading', true);
        http.patch(`${documentApiPrefix(document)}/cancelar/${document.id}`, [], {
            headers: {'access-token': [document.access_token]}
        }).then((resp) => {
            if (!(resp.data.validations)) {
                Toast.success('DOCUMENTS.MESSAGES.SUCCESS_CANCEL_DOCUMENT');
            }
            commit('reloadIndex', true);
        }).catch((err) => {
            commit('changeLoading', false);
            errorMsg.errorMsg(err);
        });
    },
    showSigner({commit},{id}){
        commit('changeLoading', true);
        http.get(`v1/signatarios/${id}`).then((resp) => {
            commit('showSigner', resp.data);
            commit('changeLoading', false);
        }).catch((err) => {
            commit('changeLoading', false);
            commit('showSigner', {});
            errorMsg.errorMsg(err);
        })
    },
    alterConfigSignerDoc({commit},{data})
    {
        commit('changeLoading', true);
        const payload = {...data};
        if (!isV3Signer(payload)) {
            delete payload.signature_mode;
            delete payload.signature_host;
        }
        http.put(`/v1/signatarios/${payload.id}`, payload).then(() => {
            Toast.success('Atualizado com Sucesso!');
            document.getElementById('closeX').click();
            commit('reloadIndex', true);
        }).catch((err) => {
            commit('changeLoading', false);
            errorMsg.errorMsg(err);
        })
    }
}
